<template>
  <v-wait :for="loaderId">
    <template slot="waiting">
      <b-row>
        <b-col cols="12" class="d-flex justify-content-center">
          <half-circle-spinner />
        </b-col>
      </b-row>
    </template>
    <template>
      <b-row class="v2_font_size_18 v2_color_primary_teal">
        <b-col xl="4" lg="6" md="12">
          <b-row>
            <b-col xl="5" md="6" sm="12" class="mb-3 mb-md-0">
              <specialties-statistics
                v-if="specialtiesStatistics"
                :data="specialtiesStatistics"
              />
            </b-col>
            <b-col xl="7" md="6" sm="12">
              <info-donut-with-legend
                v-if="profileDataStatistic && profileDataStatistic.gender"
                :chart-data="profileDataStatistic.gender"
                chartTitle="Genders"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col xl="5" lg="6" md="12">
          <b-row>
            <b-col sm="12" md="6">
              <info-donut-with-legend
                v-if="profileDataStatistic && profileDataStatistic.age"
                :chart-data="profileDataStatistic.age"
                chartTitle="Ages"
              />
            </b-col>
            <b-col sm="12" md="6">
              <info-donut-with-legend
                v-if="profileDataStatistic && profileDataStatistic.race"
                :chart-data="profileDataStatistic.race"
                chartTitle="Race"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col xl="3" lg="12" md="12">
          <usa-map-chart
            v-if="locationStatistics"
            :chart-data="locationStatistics"
            chart-title="Physician Location"
          />
        </b-col>
      </b-row>
    </template>
  </v-wait>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners';
import InfoDonutWithLegend from '@/components/dashboard/metrics/components/InfoDonutWithLegend';
import UsaMapChart from '@/components/dashboard/metrics/components/UsaMapChart';
import SpecialtiesStatistics from '@/components/mss_admin/dashboard/metrics/components/SpecialtiesStatistics';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import Api from '@/providers/Api';

export default {
  name: 'NotTakenSocietyMetrics',
  components: {
    HalfCircleSpinner,
    InfoDonutWithLegend,
    UsaMapChart,
    SpecialtiesStatistics,
  },
  data: function () {
    return {
      specialtiesStatistics: null,
      profileDataStatistic: null,
      locationStatistics: null,
    };
  },
  created: function () {
    this.getStatistics();
  },
  computed: {
    loaderId: function () {
      return `loading_${this.$options.name}`;
    },
  },
  methods: {
    getStatistics: async function () {
      this.$wait.start(this.loaderId);
      try {
        const fetchResults = await Promise.allSettled([
          Api.mssAdminGetSpecialtiesStatistics(),
          Api.mssAdminGetProfileDataStatistic(),
          Api.mssAdminGetLocationStatistic(),
        ]);
        if (fetchResults[0] && fetchResults[0].status === 'fulfilled')
          this.specialtiesStatistics = fetchResults[0].value;
        else
          this.$toasted.error('Unable to upload specialties statistics.', {
            duration: 3000,
          });
        if (fetchResults[1] && fetchResults[1].status === 'fulfilled')
          this.profileDataStatistic = fetchResults[1].value;
        else
          this.$toasted.error('Unable to upload profile data statistics.', {
            duration: 3000,
          });
        if (fetchResults[2] && fetchResults[2].status === 'fulfilled')
          this.locationStatistics = fetchResults[2].value;
        else
          this.$toasted.error('Unable to upload location data statistics.', {
            duration: 3000,
          });
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.$wait.end(this.loaderId);
      }
    },
  },
};
</script>

<style scoped></style>
